"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShardUploader = exports.CHUNK_SIZE = void 0;
const tslib_1 = require("tslib");
const runtime_1 = require("../../runtime");
const base64_1 = require("../../utils/base64");
exports.CHUNK_SIZE = 1024 * 1024 * 16;
class ShardUploader {
    constructor(fileTokens, data) {
        this.fileTokens = fileTokens;
        this.data = data;
        const { upload_url, bucket, key, token } = fileTokens;
        this.baseURL = `${upload_url}/buckets/${bucket}/objects/${(0, base64_1.utoh)(key)}/uploads`;
        this.upToken = `UpToken ${token}`;
    }
    request(request, options) {
        var _a;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const { status, body } = yield runtime_1.SDKRuntime.http.request({
                method: request.method,
                url: this.baseURL + ((_a = request.path) !== null && _a !== void 0 ? _a : ''),
                header: {
                    Authorization: this.upToken,
                },
                body: request.body,
            }, options);
            if (status >= 400) {
                throw new Error(body.error);
            }
            return body;
        });
    }
    getUploadId(options) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const { uploadId } = yield this.request({ method: 'POST' }, options);
            return uploadId;
        });
    }
    uploadChunk(uploadId, partNumber, data, options) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const { etag } = yield this.request({
                method: 'PUT',
                path: `/${uploadId}/${partNumber}`,
                body: data,
            }, options);
            return etag;
        });
    }
    finish(uploadId, fileName, parts) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            yield this.request({
                method: 'POST',
                path: `/${uploadId}`,
                body: {
                    parts,
                    fname: fileName,
                    mimeType: this.fileTokens.mime_type,
                },
            });
        });
    }
    abort(uploadId) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            yield this.request({ method: 'DELETE', path: `/${uploadId}` });
        });
    }
    upload(fileName, options) {
        var e_1, _a;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const uploadId = yield this.getUploadId(Object.assign(Object.assign({}, options), { onProgress: undefined }));
            const parts = [];
            let uploaded = 0;
            let uploadedChunks = 0;
            const handleProgressChange = ({ loaded }) => {
                loaded += uploadedChunks * exports.CHUNK_SIZE;
                if (loaded <= uploaded) {
                    return;
                }
                uploaded = loaded;
                if (this.data.size) {
                    options.onProgress({
                        loaded,
                        total: this.data.size,
                        percent: (loaded / this.data.size) * 100,
                    });
                }
                else {
                    options.onProgress({ loaded });
                }
            };
            try {
                try {
                    for (var _b = (0, tslib_1.__asyncValues)(this.data), _c; _c = yield _b.next(), !_c.done;) {
                        const chunk = _c.value;
                        if (!chunk) {
                            break;
                        }
                        const partNumber = parts.length + 1;
                        const etag = yield this.uploadChunk(uploadId, partNumber, chunk, Object.assign(Object.assign({}, options), { onProgress: (options === null || options === void 0 ? void 0 : options.onProgress) ? handleProgressChange : undefined }));
                        parts.push({ partNumber, etag });
                        uploadedChunks++;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            catch (error) {
                yield this.abort(uploadId);
                throw error;
            }
            yield this.finish(uploadId, fileName, parts);
        });
    }
}
exports.ShardUploader = ShardUploader;
